import React from "react"
import HeaderView from "../header/HeaderView"
import "./LayoutStyle.css"
import { Box } from "@material-ui/core"

const LayoutView = ({ children }) => {
	return (
		<div className="layoutContainer">
			<HeaderView />
			<Box
				style={{
					margin: 0,
					padding: 0,
					marginTop: "94px",
				}}
			>
				{children}
			</Box>
		</div>
	)
}

export default LayoutView
